import { jsx as _jsx } from "react/jsx-runtime";
export function StepIndicator({ current, total }) {
    return (_jsx("div", { className: "flex justify-center gap-2", children: Array.from({ length: total }, (_, i) => (_jsx("div", { className: `w-2 h-2 rounded-full transition-colors ${i <= current ? 'bg-white' : 'bg-gray-600'}` }, i))) }));
}
